// 浏览器存储持久化 — 防止系统在磁盘压力下自动清除 IndexedDB 数据
// 参见: https://developer.mozilla.org/en-US/docs/Web/API/Storage_API

let _persisted = false
let _checked = false

/**
 * 请求浏览器将 origin 存储标记为 persistent。
 * 一旦标记，即使磁盘空间不足、用户长期不用，系统也不会自动清除该 origin 的数据。
 *
 * 注意：浏览器要求此 API 必须在用户手势（click/touchstart）上下文中调用。
 *
 * @returns true 表示已成功持久化（或已经是 persistent）
 */
export async function requestPersistentStorage(): Promise<boolean> {
  if (_checked) return _persisted
  _checked = true

  if (!navigator.storage?.persist) {
    console.warn('[StoragePersist] navigator.storage.persist 不可用（非 Chromium/Firefox）')
    return false
  }

  try {
    // 已经持久化 → 直接返回
    const already = await navigator.storage.persisted()
    if (already) {
      _persisted = true
      console.log('[StoragePersist] 存储已持久化')
      return true
    }

    // 请求持久化（必须在用户手势上下文中调用）
    const persisted = await navigator.storage.persist()
    _persisted = persisted
    console.log(`[StoragePersist] 持久化请求结果: ${persisted}`)
    return persisted
  } catch (err) {
    console.error('[StoragePersist] 持久化请求失败:', err)
    return false
  }
}

/**
 * 检查当前存储是否已持久化（不触发请求）
 */
export async function isStoragePersisted(): Promise<boolean> {
  if (!navigator.storage?.persisted) return false
  return navigator.storage.persisted()
}
